import { Stack, styled } from '@mui/material';

export const TooltipContentRow = styled(Stack)({
  flexDirection: 'row',
  alignItems: 'center',
  gap: '0.375rem',
});

export const TooltipIconWrapper = styled('span')({
  display: 'flex',
  alignItems: 'center',
  flexShrink: 0,
});
